import script from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=1df60309&lang=css"

const __exports__ = script;

export default __exports__